/* ••[1]••••••••••••••••••••••••• TestimonialVideoModel.ts •••••••••••••••••••••••••••••• */
import ProviderFactory from "../core/ProviderFactory";
import OcontentMiscProvider from "../core/providers/ocontent/OcontentMiscProvider";
import {
  OcontentProviderType,
  ProviderConfiguration,
} from "../core/types/Provider";

import { TestimonialVideo } from "../core/types/TestimonialVideo";
export default abstract class TestimonialVideoModel {
  private static testimonialVideoCache: Array<TestimonialVideo>;
  private static miscProvider: OcontentMiscProvider = ProviderFactory.create(
    OcontentProviderType.Misc,
    ProviderConfiguration.ocontent
  );

  public static async getTestimonialVideoData(): Promise<Array<TestimonialVideo> | null> {
    if (!TestimonialVideoModel.testimonialVideoCache) {
      TestimonialVideoModel.testimonialVideoCache =
        await TestimonialVideoModel._getTestimonialVideoData();
    }

    return TestimonialVideoModel.testimonialVideoCache;
  }

  private static async _getTestimonialVideoData(): Promise<Array<TestimonialVideo> | null> {
    try {
      const items =
        await TestimonialVideoModel.miscProvider.getTestimonialVideoData();
      return items;
    } catch (err) {
      return null;
    }
  }
}
